import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { GtmGenericDialogsService, GtmImportPack, provideGtmGenericDialogsService } from '@partners/gtm';
import { DialogContainerComponent, DialogImportPack, IDialogConfig } from '@partners/ui';

@Component({
  standalone: true,
  providers: [provideGtmGenericDialogsService()],
  imports: [DialogImportPack, GtmImportPack],
  template: `
    <dialog-container #container gtmFunnelStepEvent="funnelStepEvent">
      <ng-template dialogBody let-context>
        <span>{{ context.message }}</span>
      </ng-template>
    </dialog-container>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tooltip-dialog'
  }
})
export class TooltipComponent implements OnInit {
  private readonly _gtmService = inject(GtmGenericDialogsService);

  @ViewChild('container', { static: true, read: DialogContainerComponent })
  dialogContainer: DialogContainerComponent;

  ngOnInit() {
    this.setGtmDialogConfig();
  }

  setGtmDialogConfig() {
    const dialogConfig = this.dialogContainer.dialogConfig as IDialogConfig;

    const gtmDialogConfig = {
      message: dialogConfig.message || dialogConfig.title
    };

    this._gtmService.setDialogConfig(gtmDialogConfig);
  }
}
